import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import TriangleDown from '../../../../assets/icons/triangleDown.svg';
import styles from './Label.css';
const Label = ({ label }) => (_jsxs(_Fragment, { children: [_jsx(TriangleDown, { className: styles.icon, "data-omitsvgclassname": "true" }, void 0), _jsx("span", Object.assign({ className: styles.label }, { children: label }), void 0)] }, void 0));
export default memo(Label);
